import VuePerfectScrollbar from 'vue-perfect-scrollbar'

/**
 * @type {import('./index.d.ts')['VuePerfectScrollbar']}
 */
const scrollbar = VuePerfectScrollbar.default ? VuePerfectScrollbar.default : VuePerfectScrollbar

export default scrollbar
